export type SummarizerTimeRange = 'day' | 'week' | 'month' | 'year';

export interface SummarizerRequest {
  lang: string;
  region: string;
  query: string;
  time_range: SummarizerTimeRange;
  token: string;
}

export interface SummarizerResponse {
  // The API response shape may evolve; keep it flexible.
  [key: string]: unknown;
}

export async function summarizeNews(
  req: SummarizerRequest
): Promise<SummarizerResponse> {
  const { token, ...body } = req;

  const res = await fetch('https://agent.summarizer.swarmind.ai/summarize', {
    method: 'POST',
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    let detailsText = '';
    let detailsJson: any = null;
    try {
      const ct = res.headers.get('content-type') || '';
      if (ct.includes('application/json')) {
        detailsJson = await res.json();
        detailsText = JSON.stringify(detailsJson);
      } else {
        detailsText = await res.text();
      }
    } catch {
      detailsText = await res.text().catch(() => '');
    }

    const err: any = new Error(
      `Summarizer request failed: ${res.status} ${res.statusText}${detailsText ? ` ${detailsText}` : ''}`
    );
    err.status = res.status;
    err.details = detailsJson || detailsText;

    const msg =
      (detailsJson && (detailsJson.error || detailsJson.message)) || detailsText;
    if (typeof msg === 'string' && msg.toLowerCase().includes('empty news search output')) {
      err.code = 'EMPTY_NEWS_OUTPUT';
    }
    throw err;
  }

  return (await res.json()) as SummarizerResponse;
}

